function identifyUser(email) {
  FreshworksWidget("identify", "ticketForm", { email });
}

function hideLauncher() {
  FreshworksWidget("hide", "launcher");
}

function open(param) {
  param ? FreshworksWidget("open", param) : FreshworksWidget("open");
}

function close() {
  FreshworksWidget("close");
}

function openProofOfPaymentForm() {
  FreshworksWidget("prefill", "ticketForm", {
    subject: "Comprovante de pagamento"
  });
  open("ticketForm");
}

export default {
  identifyUser,
  hideLauncher,
  open,
  close,
  openProofOfPaymentForm
};



// WEBPACK FOOTER //
// ./src/utils/freshDesk.js